import styled from "styled-components";

export const AuthModalSpinnerWrapper = styled.div`
  width: 392px;
  height: 445px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
